import React from 'react'
import {
  Badge,
  CardText,
  Label
} from 'reactstrap'
import PropTypes from 'prop-types'
import { v1 as uuidv1 } from 'uuid'
import { useTranslation } from 'react-i18next'

const ReferenceLanguages = ({ badgesColor = 'primary', locales, withoutLabel = false }) => {
  const { t } = useTranslation('ReferenceLanguages')

  return (
    <CardText tag="div">
      <div className="d-flex flex-column">
        {withoutLabel || (
          <Label>
            {t('locales')}
          </Label>
        )}

        <div className="d-flex flex-row flex-wrap gap-1">
          {locales.map((locale) => (
            <Badge
              color={badgesColor}
              key={uuidv1()}
            >
              {locale.label}
            </Badge>
          ))}
        </div>
      </div>
    </CardText>
  )
}

ReferenceLanguages.propTypes = {
  badgesColor: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired
  })).isRequired,
  withoutLabel: PropTypes.bool
}

export default ReferenceLanguages
